<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('simple.edit')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="edit">

                <loading slot="waiting"/>

                <form @submit.prevent="validate_edit">


                    <div class="form-group">

                        <label for="name">{{ $t('simple.name') }}</label>

                        <input
                            class="form-control"
                            type="text"
                            id="name"
                            name="name"
                            v-validate="'required|max:15'"
                            v-model="name"
                        >

                        <small v-show="errors.has('name')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('name') }}</small>

                    </div>

                </form>

            </v-wait>

        </div>

        <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>
          <div v-b-tooltip.hover.right="{
                 title: !user_permissions.includes('update-categories')? $t('permission.permission_denied', { permission: 'update-categories' }) : '',customClass: 'tooltip-dark' }"
               style="display: inline-block">
            <b-button @click="validate_edit()" variant="primary" :class="!user_permissions.includes('update-categories') ? 'cursor-not-allowed' : ''"
                      :disabled="!user_permissions.includes('update-categories')">{{ $t('simple.save') }}</b-button>
          </div>
        </div>


        </div>
      </div>
    </div>
</template>
<script>

    import {mapGetters} from "vuex";

    export default {

        mounted: function () {
            // Component mounted
            console.log('Category Edit Modal mounted');

            // Get data to edit
            this.edit(this.id);
        },

        destroyed() {
            console.log('Category Edit Modal destroyed.');
        },

        data: function() {
             return  {

                categories_api: '/api/v1/settings/category/',

                name: '',

            }
        },

        methods: {

            edit: async function(id) {

                 // Loading start
                this.$wait.start('edit');

                // Category edit data
                await axios.get(this.categories_api + id)
                
                    .then((response) => {

                        // Loading stop
                        this.$wait.end('edit');

                        // Update modal data
                        this.name = response.data.name;
                        //console.log(response);

                    })
                    .catch((error) => {

                        // Loading stop
                        this.$wait.end('edit');
                       // Show error
                          Vue.toasted.error(this.$t('simple.error_info'));
                        // Log to console
                        console.log(error);

                    });

            },

            category_edit: async function(){

                 // Loading start
                this.$wait.start('edit');

                // Update category
                await axios.put(this.categories_api + this.id, {
                    name: this.name,
                  })
                  .then((response) => {

                        // Loading stop
                        this.$wait.end('edit');

                        // Show success
                        Vue.toasted.success(this.$t('simple.success_info'));

                        // Close modal
                        this.$close(true);

                    }
                )
                  .catch((error) => {

                        // Loading stop
                        this.$wait.end('edit');

                        // Show error
                      if (error.response && error.response.status === 403) {
                        Vue.toasted.error(this.$t('permission.permission_denied',{ permission: 'update-categories'}));
                      } else {
                        Vue.toasted.error(this.$t('simple.error_info'));
                      }
                        // Log to console
                        //console.log(error);

                        // Close modal
                        //this.$close(true);

                    }
                );

            },

            validate_edit: async function() {
                // validate all fields
                await this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Send it to account edit function
                        this.category_edit();
                    }
                });
            },
        },
      computed: {
        // Map getters
        ...mapGetters({
          user_permissions: 'User/getUserPermissions'
        })
      },
    }
</script>